import React, { Fragment, useState, useEffect } from 'react';
import '../assets/css/BusinessHoursSection.scss';
function PymeCategoriesSection(props) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    props && props.categories && setCategories(props.categories);
  }, [props]);

  return (
    <Fragment>
      <div key={props.id} className="row px-0 mx-0 pb-0">
        <div className="d-flex flex-column w-100">
          <h5 className="m-0 mb-2">
            <strong>Productos y/o servicios disponibles</strong>
          </h5>
          {categories.map((category, index) => (
            <div key={index} className={'mx-1 my-3' + (!index ? ' mt-4' : '')}>
              <h5 className="text-black-50">
                <strong>{category.name}</strong>
              </h5>
              <div className="d-flex flex-wrap justify-content-center justify-content-md-start">
                {category.subCategories.map((subCategory, subIndex) => (
                  <h5
                    key={subIndex}
                    className={
                      'd-inline-block mx-2 ml-md-4 mr-md-0 my-3 px-5 py-2 border border-dark rounded'
                    }
                  >
                    {subCategory}
                  </h5>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
}

export default PymeCategoriesSection;
